import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CargueArchivosComponent } from './components/cargue-cobradores/cargue-archivo.component';
import { CargueSegurosComponent } from './components/cargue-seguro/cargue-seguro.component';
import { CargueLifeMilesComponent } from './components/cargue-lifeMiles/cargue-lifeMiles.component';
import { CargueBloqueadasComponent } from './components/cargue-cuentasBloqueadas/cargue-cuentasBloqueadas.component';
import { CargueProductosTPComponent } from './components/cargue-productosTP/cargue-productosTP.component';

const routes: Routes = [
  {
    path: "cargue-cobradores",
    component: CargueArchivosComponent,
    data: {
      title: 'Cargue Masivo Archivos'
    },

  },
  {
    path: "cargue-seguros",
    component: CargueSegurosComponent,
    data: {
      title: 'Cargue Masivo Cobradores'
    },

  },
  {
    path: "cargue-lifemiles",
    component: CargueLifeMilesComponent,
    data: {
      title: 'Cargue Masivo LifeMiles'
    },

  },
  {
    path: "cargue-bloqueo",
    component: CargueBloqueadasComponent,
    data: {
      title: 'Cargue Cuentas Bloqueadas'
    },

  },
  {
    path: "cargue-productosTP",
    component: CargueProductosTPComponent,
    data: {
      title: 'Cargue Masivo Productos TP'
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CargueRoutingModule { }